import { Button, Card, Col, Row } from "react-bootstrap";
import { CiLock } from "react-icons/ci";
import { LuDollarSign } from "react-icons/lu";
import { TbCreditCardRefund } from "react-icons/tb";
import { BsBuildingCheck } from "react-icons/bs";
import { useDispatch } from "react-redux";
import { getScrapperStart } from "../../../Store/Slices/scrapperSlice";
import { IoMdCloseCircleOutline } from "react-icons/io";

const QuickFilters = ({ data, setFilterObj, setIsInitial, currentPage, pageSize }) => {
    const dispatch = useDispatch();
    let filterData = data

    const removeKeys = (obj, keysToRemove) => {
        return Object.fromEntries(
            Object.entries(obj).filter(([key]) => !keysToRemove.includes(key))
        );
    };

    const handleSearch = () => {
        // debugger
        let orgIds = data?.organization_ids
        let orglocations = data?.person_locations
        let orgEmailStatus = data?.contact_email_status_v2
        let orgPersonTitle = data?.person_titles
        // let orgIndutries = data?.keywords
        let orgIndutries = data?.q_organization_keyword_tags

        const keysToDelete = ["organization_ids", "person_locations", "contact_email_status_v2",
            "person_titles", "q_organization_keyword_tags", "keywords"
        ];
        const updated = removeKeys(data, keysToDelete);
        // debugger
        // const { organization_ids, ...newObj } = data;
        updated['organization_ids'] = orgIds?.map((x) => x.id)
        updated['person_locations'] = orglocations?.map((x) => x.value)
        updated['contact_email_status_v2'] = orgEmailStatus?.map((x) => x.value)
        updated['person_titles'] = orgPersonTitle?.map((x) => x.value)
        // updated['keywords'] = orgIndutries?.map((x) => x.value)
        updated['q_organization_keyword_tags'] = orgIndutries?.map((x) => x.value)
        updated['page'] = currentPage
        updated['per_page'] = pageSize
        updated['organization_names'] = orgIds?.map((x) => x.label)
        setIsInitial(false);
        // console.log('PAYLOAD FROM QUICK FILTERS:', updated)
        dispatch(getScrapperStart(updated))
    }
    // console.log('filter data:', filterData)
    const clearFilters = (name, value) => {
        let updatedItems;
        if (name === 'organization_ids') {
            updatedItems = filterData?.organization_ids.filter(item => item.id !== value);
        }

        if (name === 'keywords' || name === 'q_organization_keyword_tags' || name === 'person_titles' || name === 'person_locations' || name === 'contact_email_status_v2') {
            updatedItems = filterData?.[name].filter(item => item.label !== value);
        }
        if (name === 'organization_num_employees_ranges'
            // || name === 'person_locations'
        ) {
            // if (name !== 'organization_ids' && name !== 'q_keywords' && name !== 'person_locations') {
            updatedItems = filterData?.[name].filter(item => item !== value);
        }

        setFilterObj(prev => ({
            ...prev,
            [name]: name === 'q_keywords' ? value : updatedItems
        }));
    }

    const handleClearAll = () => {
        setFilterObj(prev => ({
            ...prev,
            "contact_email_status_v2": [],
            "q_keywords": "",
            "person_titles": [],
            "person_locations": [],
            "organization_ids": [],
            "keywords": [],
            "organization_num_employees_ranges": [],
            "q_organization_keyword_tags": []
        }));
    }

    const excludedKeys = [
        'fields',
        'organization_domains',
        'include_similar_titles',
        'name_search'
    ];

    const showClearAll = () => {
        let filledCount = 0;
        let hasArrayWithMultipleValues = false;

        for (const [key, value] of Object.entries(filterData)) {
            if (excludedKeys.includes(key)) continue;

            if (Array.isArray(value)) {
                if (value.length > 0) filledCount++;
                if (value.length > 1) hasArrayWithMultipleValues = true;
            } else if (value !== "" && value !== null && value !== undefined) {
                filledCount++;
            }
        }

        return filledCount >= 2 || hasArrayWithMultipleValues;
    };

    return (<>
        <Row className="justify-content-center align-items-center mt-3">
            <Col xs={12} md={9} lg={8} className="p-0">
                <Card className="mb-3 p-0">
                    <Card.Body>
                        <h5 className="card-title mb-3">Quick Filters</h5>
                        <Row className="g-2">
                            <Col xs={12} md={6}>
                                <div className="vstack gap-3">
                                    <div className="vstack">
                                        <div className="mb-2">Company</div>
                                        {filterData?.organization_ids?.length ?
                                            <div className="hstack gap-2 flex-wrap">
                                                {filterData?.organization_ids?.map((data) => (
                                                    <span className="badge text-body fw-normal border py-1 px-2 hover-span">{data?.name}
                                                        <IoMdCloseCircleOutline fontSize={14} className="ms-1 hover-clear-icon" onClick={() => clearFilters('organization_ids', data?.id)} />
                                                    </span>
                                                ))}
                                            </div>
                                            : <span>-</span>
                                        }
                                    </div>
                                    <div className="vstack">
                                        <div className="mb-2">Job Titles</div>
                                        {filterData?.person_titles?.length ?
                                            <div className="hstack gap-2 flex-wrap">
                                                {filterData?.person_titles?.map((data) => (
                                                    <span className="badge text-body fw-normal border py-1 px-2 hover-span">{data.label}
                                                        <IoMdCloseCircleOutline fontSize={14} className="ms-1 hover-clear-icon" onClick={() => clearFilters('person_titles', data.label)} />
                                                    </span>
                                                ))}
                                            </div>
                                            : <span>-</span>
                                        }
                                    </div>
                                    {/* <div className="vstack">
                                        <div className="mb-2">No.of Employees</div>
                                        {filterData?.organization_num_employees_ranges?.length ?
                                            <div className="hstack gap-2 flex-wrap">
                                                {filterData?.organization_num_employees_ranges?.map((data) => (
                                                    <span className="badge text-body fw-normal border py-1 px-2 hover-span">{data}
                                                        <IoMdCloseCircleOutline fontSize={14} className="ms-1 hover-clear-icon" onClick={() => clearFilters('organization_num_employees_ranges', data)} />
                                                    </span>
                                                ))}
                                            </div>
                                            : <span>-</span>
                                        }
                                    </div> */}
                                    <div className="vstack">
                                        <div className="mb-2">Name</div>
                                        {filterData?.q_keywords !== "" ?
                                            <div className="hstack gap-2 flex-wrap">
                                                {/* {filterData?.organization_num_employees_ranges?.map((data) => ( */}
                                                <span className="badge text-body fw-normal border py-1 px-2 hover-span">{filterData?.q_keywords}
                                                    <IoMdCloseCircleOutline fontSize={14} className="ms-1 hover-clear-icon" onClick={() => clearFilters('q_keywords', "")} />
                                                </span>
                                                {/* ))} */}
                                            </div>
                                            : <span>-</span>
                                        }
                                    </div>
                                </div>
                            </Col>
                            <Col xs={12} md={6}>
                                <div className="vstack gap-3">
                                    <div className="vstack">
                                        <div className="mb-2">Email Status</div>
                                        {filterData?.contact_email_status_v2?.length ?
                                            <div className="hstack gap-2 flex-wrap">
                                                {filterData?.contact_email_status_v2?.map((data) => (
                                                    <span className="badge text-body fw-normal border py-1 px-2 hover-span">{data.label}
                                                        <IoMdCloseCircleOutline fontSize={14} className="ms-1 hover-clear-icon" onClick={() => clearFilters('contact_email_status_v2', data.label)} />
                                                    </span>
                                                ))}
                                            </div>
                                            : <span>-</span>
                                        }
                                    </div>
                                    <div className="vstack">
                                        <div className="mb-2">Location</div>
                                        {filterData?.person_locations?.length ?
                                            <div className="hstack gap-2 flex-wrap">
                                                {filterData?.person_locations?.map((data) => (
                                                    <span className="badge text-body fw-normal border py-1 px-2 hover-span">{data.label}
                                                        <IoMdCloseCircleOutline fontSize={14} className="ms-1 hover-clear-icon" onClick={() => clearFilters('person_locations', data.label)} />
                                                    </span>
                                                ))}
                                            </div>
                                            : <span>-</span>
                                        }
                                    </div>
                                    <div className="vstack">
                                        <div className="mb-2">Departments</div>
                                        {filterData?.q_organization_keyword_tags?.length ?
                                            <div className="hstack gap-2 flex-wrap">
                                                {filterData?.q_organization_keyword_tags?.map((data) => (
                                                    <span className="badge text-body fw-normal border py-1 px-2 hover-span">{data.label}
                                                        <IoMdCloseCircleOutline fontSize={14} className="ms-1 hover-clear-icon" onClick={() => clearFilters('q_organization_keyword_tags', data.label)} />
                                                    </span>
                                                ))}
                                            </div>
                                            : <span>-</span>
                                        }
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <div className="d-flex justify-content-end align-item-end mt-3">
                            {showClearAll() && (
                                <button type="button" class="btn btn-outline-primary btn-blue rounded-2 me-1"
                                    onClick={() => handleClearAll()}>Reset Filters</button>
                            )}
                            <button className="btn btn-primary btn-blue float-end" type="button"
                                onClick={() => handleSearch()}>Search</button>
                        </div>
                    </Card.Body>
                    {/* <Card.Footer>
                        <div className="d-flex justify-content-between">
                            <div className="hstack gap-2 align-items-center">
                                <span className="hstack p-2 w-30px h-30px bg-secondary-subtle rounded-2"><CiLock /></span>
                                <span>Unlock advanced filters:</span>
                                <span className="hstack"><LuDollarSign className="me-2" /> Revenue</span>
                                <span className="hstack"><TbCreditCardRefund className="me-2" />Funding</span>
                                <span className="hstack"><BsBuildingCheck className="me-2" />Company Lookalikes</span>
                            </div>
                            <Button variant="primary">View plans</Button>
                        </div>
                    </Card.Footer> */}
                </Card>
            </Col>
        </Row >
    </>);
}

export default QuickFilters;